import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// Service
import { ApiService } from '../../../shared/service/api.service';
import { GlobalService } from '../../../shared/service/global.service';
@Component({
  selector: 'app-compliance',
  templateUrl: './compliance.component.html',
  styles: [
  ]
})
export class ComplianceComponent implements OnInit {

  dataTitle;
  dataSection = [];
  dataEtik;
  dataBOC;
  dataInternal;
  dataCommunication;
  isActivePdf;

  constructor(private apiService: ApiService, 
              private globalService: GlobalService,
              private router: Router) {
    this.globalService.isLoading.next(true); 
  }

  ngOnInit(): void {
    // Content
    this.apiService.getDataApi('getMenuSection/compliance').subscribe(response => {
      if(response.success) {
        this.dataTitle = response.data;
        this.dataSection = response.data.section;;
        // Meta
        this.globalService.updateMeta(
          response.data.title + ' | Prime Agri Resources',
          response.data.keyword,
          response.data.metadesc
        );
        this.globalService.isLoading.next(false);
      } else {
        this.router.navigate(['/not-found']);
      }
    });

    // docs
    this.apiService.getDataApi('getDocumentYear?category=13').subscribe(response => {
      this.dataEtik = response.data[0].content;
      this.isActivePdf = response.isActive;
    });
    this.apiService.getDataApi('getDocumentYear?category=14').subscribe(response => {
      this.dataBOC = response.data[0].content;
    });
    this.apiService.getDataApi('getDocumentYear?category=15').subscribe(response => {
      this.dataInternal = response.data[0].content;
    });
    this.apiService.getDataApi('getDocumentYear?category=16').subscribe(response => {
      this.dataCommunication = response.data[0].content;
    });
  }

}
